export const CONTACT_INFO = {
  phone: {
    display: '+91 80877 29277',
  },
  email: {
    general: 'vishal@niveshright.com',
  },
} as const;
